import { DEFAULT_MENU_THEME } from "../../../config/menuThemes";
import ClassicMenuTheme from "./ClassicMenuTheme";
import GardenFreshMenuTheme from "./GardenFreshMenuTheme";
import JapaneseMinimalMenuTheme from "./JapaneseMinimalMenuTheme";
import BrewBitesMenuTheme from "./BrewBitesMenuTheme";
import NovaMenuTheme from "./NovaMenuTheme";
import MizbanSignatureMenuTheme from "./MizbanSignatureMenuTheme";
import LuxuryWhiteMenuTheme from "./LuxuryWhiteMenuTheme";
import StreetFoodMenuTheme from "./StreetFoodMenuTheme";
import RoyalGoldMenuTheme from "./RoyalGoldMenuTheme";
import PersianHeritageMenuTheme from "./PersianHeritageMenuTheme";

const menuThemeRegistry = {
  classic: ClassicMenuTheme,
  gardenFresh: GardenFreshMenuTheme,
  japaneseMinimal: JapaneseMinimalMenuTheme,
  brewBites: BrewBitesMenuTheme,
  nova: NovaMenuTheme,
  mizbanSignature: MizbanSignatureMenuTheme,
  luxuryWhite: LuxuryWhiteMenuTheme,
  streetFood: StreetFoodMenuTheme,
  royalGold: RoyalGoldMenuTheme,
  persianHeritage: PersianHeritageMenuTheme,
};

export const getMenuThemeComponent = (theme) => (
  menuThemeRegistry[theme] || menuThemeRegistry[DEFAULT_MENU_THEME]
);

export default menuThemeRegistry;
